export default __webpack_public_path__ + "static/1-7c13202587076fef1c92ea9fce84b48d.jpeg";